/**
 * Wishlist persistence layer.
 *
 * Deliberately the ONLY file that touches localStorage. Swapping this out later for
 * customer-metafield / cross-device syncing means replacing this file's two functions
 * (and making them async) without touching wishlist-service.js or wishlist-ui.js.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'lalume:wishlist:v1';

  function load() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function save(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      return true;
    } catch (e) {
      return false;
    }
  }

  window.LalumeWishlistStorage = {
    load: load,
    save: save
  };
})();
